import React from 'react'
import { EmptyStateSize } from 'shared/timber/v1/EmptyState'

import './Description.scss'

export interface EmptyStateDescriptionProps {
  size?: EmptyStateSize
  appearance?: 'condensed' | 'default'
  children: React.ReactNode
  'data-testid'?: string
}

const EmptyStateDescription = React.memo(
  ({
    size = 'md',
    children,
    appearance = 'default',
    'data-testid': dataTestId = 'empty-state-description',
  }: EmptyStateDescriptionProps) => {
    return (
      <p
        data-testid={dataTestId}
        className={[
          'EmptyStateDescription',
          `EmptyStateDescription--${size}`,
          `EmptyStateDescription--${appearance}`,
        ].join(' ')}
        data-size={size}
        data-appearance={appearance}
      >
        {children}
      </p>
    )
  },
)

EmptyStateDescription.displayName = 'EmptyState.Description'

export default EmptyStateDescription
